module.exports = "\n<span defaultOverlayTarget></span>\n<router-outlet></router-outlet>\n"